import { MAX_CONTENT_WIDTH } from "@faire/retailer-visitor-shared/features/Marketplace/styleConsts";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import styled, { css } from "styled-components";
export var Z_INDICES = {
    footer: {
        desktopAndAbove: 1
    },
    sidebar: {
        desktopAndAbove: 0,
        tablet: 102,
        mobile: 101
    }
};
export var ElevatedContentWrapper = styled(Column).withConfig({
    componentId: "sc-3c3902ff-0"
})([
    "width:100%;",
    "{",
    " margin:auto;padding:0 ",
    ";}",
    "{padding-left:0px;}"
], responsiveMediaQueries.desktopAndAbove, function(param) {
    var $maxWidth = param.$maxWidth;
    return css([
        "max-width:",
        "px;"
    ], $maxWidth !== null && $maxWidth !== void 0 ? $maxWidth : MAX_CONTENT_WIDTH);
}, getSpacing("6x"), responsiveMediaQueries.tabletAndBelow);
